import api from "../../../api/comptabilite/_operations";
import api_fpro from "../../../api/comptabilite/_proforma";

export default {
    selectOperationsCaisse(data) {
        return new Promise((resolve, reject) => {
            api.getOperationsCaisse(data).then((response) => {
                resolve(response);
            },(error) => {
                    reject(error);
            });
        });
    },

    getListeFactures(data) {
        return new Promise((resolve, reject) => {
            api.getListeFacture(data).then((response) => {
                resolve(response);
            },(error) => {
                reject(error);
            });
        });
    },

    getListeTicketCaisse(data) {
        return new Promise((resolve, reject) => {
            api.getListeTicketCaisse(data).then((response) => {
                resolve(response);
            },(error) => {
                reject(error);
            });
        });
    },

    getListeOperationsPatient(data) {
        return new Promise((resolve, reject) => {
            api.getListeOperationsPatient(data).then((response) => {
                resolve(response);
            }, (error) => {
                reject(error);
            });
        });
    },

    getListeProduitsCreances(data) {
        return new Promise((resolve, reject) => {
            api.getListeProduitsCreances(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeChargesExploitation(data) {
        return new Promise((resolve, reject) => {
            api.getListeChargesExploitation(data).then((response) => {
                resolve(response);
            },(error) => {
                reject(error);
            });
        });
    },

    getListeCoupons(data) {
        return new Promise((resolve, reject) => {
            api.getListeCoupons(data).then((response) => {
                resolve(response);
            }, (error) => {
                reject(error);
            });
        });
    },

    getListeDemandeAnnulation(data) {
        return new Promise((resolve, reject) => {
            api.getListeDemandeAnnulation(data).then((response) => {
                resolve(response);
            }, (error) => {
                reject(error);
            });
        });
    },

    getJournalTresorier(data) {
        return new Promise((resolve, reject) => {
            api.getJournalTresorier(data).then((response) => {
                resolve(response);
            }, (error) => {
                reject(error);
            });
        });
    },

    getListeReliquats(data) {
        return new Promise((resolve, reject) => {
            api.getListeReliquats(data).then((response) => {
                resolve(response);
            }, (error) => {
                reject(error);
            });
        });
    },

    getInfoProforma(data) {
        return new Promise((resolve, reject) => {
            api_fpro.getInfoProforma(data).then((response) => {
                resolve(response);
            },
            (error) => {
                reject(error);
            });
        });
    },
    
    getRemboursementAssurance(data) {
        return new Promise((resolve, reject) => {
            api.getRemboursementAssurance(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })  
    },

    getPatientResteApayer(data) {
        return new Promise((resolve, reject) => {
            api.getPatientResteApayer(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })  
    },

    getPatientCreances(data) {
        return new Promise((resolve, reject) => {
            api.getPatientCreances(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })  
    },

    getDetailsProduitsCreances(data) {
        return new Promise((resolve, reject) => {
            api.getDetailsProduitsCreances(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    saveBonMedical(data) {
        return new Promise((resolve, reject) => {
            api.saveBonMedical(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })  
    },

    getReliquatByID(data) {
        return new Promise((resolve, reject) => {
            api.getReliquatByID(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeBonMedical(data) {
        return new Promise((resolve, reject) => {
            api.getListeBonMedical(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getInfoFacturationBonConsultation(data) {
        return new Promise((resolve, reject) => {
            api.getInfoFacturationBonConsultation(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getInfoFacturationBonMedical(data) {
        return new Promise((resolve, reject) => {
            api.getInfoFacturationBonMedical(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getCreanceAssurance(data) {
        return new Promise((resolve, reject) => {
            api.getCreanceAssurance(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getFactureAssuranceSociete(data) {
        return new Promise((resolve, reject) => {
            api.getFactureAssuranceSociete(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    
    getDetailFactureAssuranceSociete(data) {
        return new Promise((resolve, reject) => {
            api.getDetailFactureAssuranceSociete(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    arreterFactureAssuranceSociete(data) {
        return new Promise((resolve, reject) => {
            api.arreterFactureAssuranceSociete(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    manageFactureAssuranceSociete(data) {
        return new Promise((resolve, reject) => {
            api.manageFactureAssuranceSociete(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    
    getSuiviFactureAssurance(data) {
        return new Promise((resolve, reject) => {
            api.getSuiviFactureAssurance(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    checkIfSocietesHasFactureForfait(data) {
        return new Promise((resolve, reject) => {
            api.checkIfSocietesHasFactureForfait(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    deposerFactureSociete(data) {
        return new Promise((resolve, reject) => {
            api.deposerFactureSociete(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeDemandeAutorisation(data) {
        return new Promise((resolve, reject) => {
            api.getListeDemandeAutorisation(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getDetailDemandeAutorisation(demande_id) {
        return new Promise((resolve, reject) => {
            api.getDetailDemandeAutorisation(demande_id).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    validerDemandeAutorisation(demande_id) {
        return new Promise((resolve, reject) => {
            api.validerDemandeAutorisation(demande_id).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
}